import { defaultHTTPRequests } from '../http-request-service';

/**
 *  Costante con tutte le chiamate inerenti a questa folder ( AUTH )
 */
export const paths = {
    LOGIN: '/pml/login',
    LOGIN_SAML: '/pml/loginSaml',
    LOGOUT_SAML: '/samlAuth/logoutArmonia?idAPP=arm'
}

/**
 *  Funzione per effettuare la login
 * @param {Object} params - Oggetto contenente username e password
 */

export const POST_LOGIN = (params) => {
    let _body = {};
    if (params)
        Object.keys(params).forEach((value) => {
            _body[value] = params[value];
        });
        localStorage.removeItem("filters");
    return defaultHTTPRequests("POST", paths.LOGIN, null, _body);
}
/**
 *  Funzione per effettuare la login
 */

export const GET_LOGIN_SAML = (params) => {
    localStorage.removeItem("filters");
    return defaultHTTPRequests("GET", paths.LOGIN_SAML, null, null);
}
/**
 *  Funzione per effettuare la logOUT
 */

export const GET_LOGOUT_SAML = (params) => {
    return defaultHTTPRequests("GET", paths.LOGOUT_SAML, null, null);
}
